const decodeHtml = (str) => {
    var map =
    {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#38;': "&",
        '&#39;': "'",
        '&#34;': '"'
    };
    return str.toString().replace(/&amp;|&lt;|&gt;|&quot;|&#38;|&#39;|&#34;/g, function(m) {return map[m];});
}

export default decodeHtml